<template>
  <b-container fluid>
         <b-row>
           <b-col xl="12" lg="12" sm="12">
             <iq-card>
               <template v-slot:body>
                  <b-row>
                      <b-col v-if="notFound" xl="12" lg="12" sm="12" class="text-danger mb-2">
                          <div class="bg-gray pt-2 pb-2 pl-3">
                              <span>{{ (currentLocale === 'bn') ? "তথ্য পাওয়া যায়নি..!" : "Data not found..!" }}</span>
                          </div>
                          </b-col>
                          <b-col xl="12" lg="12" sm="12">
                            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                            <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" enctype="multipart/form-data">
                                <b-overlay :show="unitLoad">
                                    <!-- Student Type & Registration ID -->
                                            <b-row>
                                            <b-col xl="6" lg="6" sm="12">
                                            <ValidationProvider name="Registration ID" vid="registration_id" rules="required|integer">
                                            <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="registration_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                              {{$t('child_admission_management.registration_id')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-input class="form-control"
                                            v-model="assign.registration_id"
                                            id="registration_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                                  {{ errors[0] }}
                                            </div>
                                            </b-form-group>
                                            </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                            <ValidationProvider name="Applicants Name" vid="name">
                                            <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="name"
                                            >
                                            <template v-slot:label>
                                             {{$t('child_admission_management.name_en')}}
                                            </template>
                                            <b-form-input class="form-control"
                                            v-model="assign.name"
                                            id="name"
                                            disabled
                                            ></b-form-input>
                                            </b-form-group>
                                            </ValidationProvider>
                                            </b-col>
                                            </b-row>
                                            <!-- Applicant's Name & Address -->
                                            <b-row>
                                            <b-col xl="6" lg="6" sm="12">
                                            <ValidationProvider name="Applicants Name" vid="name_bn">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="name_bn"
                                            >
                                              <template v-slot:label>
                                                {{$t('child_admission_management.name_bn')}}
                                              </template>
                                              <b-form-input class="form-control"
                                              v-model="assign.name_bn"
                                              id="name_bn"
                                              disabled
                                              ></b-form-input>
                                            </b-form-group>
                                            </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                            <ValidationProvider name="Student Type" vid="student_type">
                                            <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="student_type"
                                            >
                                            <template v-slot:label>
                                              {{$t('child_admission_management.student_type')}}
                                            </template>
                                            <b-form-input
                                              plain
                                              v-model="assign.student_type"
                                              id="student_type"
                                              disabled
                                             >
                                            </b-form-input>
                                            </b-form-group>
                                            </ValidationProvider>
                                            </b-col>
                                            </b-row>
                                            <!-- Organization Name & Institute Type -->
                                            <b-row>
                                            <b-col xl="6" lg="6" sm="12">
                                            <ValidationProvider name="Address" vid="address">
                                            <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="address"
                                            >
                                            <template v-slot:label>
                                              {{$t('child_admission_management.address')}}
                                            </template>
                                            <b-form-input class="form-control"
                                            v-model="assign.address"
                                            id="address"
                                            disabled
                                            ></b-form-input>
                                            </b-form-group>
                                            </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                            <ValidationProvider name="Address" vid="address_bn">
                                            <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="address_bn"
                                            >
                                            <template v-slot:label>
                                             {{$t('child_admission_management.address_bn')}}
                                            </template>
                                            <b-form-input class="form-control"
                                            v-model="assign.address_bn"
                                            id="address_bn"
                                            disabled
                                            ></b-form-input>
                                            </b-form-group>
                                            </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                            <ValidationProvider name="Organization Name" vid="org_name">
                                            <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="org_name"
                                            >
                                            <template v-slot:label>
                                              {{$t('child_admission_management.organization_name')}}
                                            </template>
                                            <b-form-input
                                              plain
                                              v-model="assign.org_name"
                                              id="org_name"
                                              disabled
                                            >
                                            </b-form-input>
                                            </b-form-group>
                                            </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                            <ValidationProvider name="Institute Type" vid="institute_type">
                                            <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="institute_type"
                                            >
                                            <template v-slot:label>
                                              {{$t('child_admission_management.institute_type')}}
                                            </template>
                                            <b-form-input
                                              plain
                                              v-model="assign.institute_type"
                                              id="institute_type"
                                              disabled
                                            >
                                            </b-form-input>
                                            </b-form-group>
                                            </ValidationProvider>
                                            </b-col>
                                            </b-row>
                                            <!-- Institute Name & Class -->
                                            <b-row>
                                            <b-col xl="6" lg="6" sm="12">
                                            <ValidationProvider name="Institute Name" vid="institute_name">
                                            <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="institute_name"
                                            >
                                            <template v-slot:label>
                                              {{$t('child_admission_management.institute_name')}}
                                            </template>
                                            <b-form-input
                                              plain
                                              v-model="assign.institute_name"
                                              id="institute_name"
                                              disabled
                                              >
                                              </b-form-input>
                                              </b-form-group>
                                              </ValidationProvider>
                                              </b-col>
                                              <b-col xl="6" lg="6" sm="12">
                                              <ValidationProvider name="Contact No" vid="contact_no" rules="required|numeric|min:11|max:11">
                                              <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="legal_guardian"
                                                slot-scope="{ valid, errors }"
                                              >
                                              <template v-slot:label>
                                                {{$t('child_admission_management.contact_no')}}
                                              </template>
                                              <b-form-input
                                              id="contact_no"
                                              v-model="assign.contact_no"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                                disabled
                                              ></b-form-input>
                                              <div class="invalid-feedback">
                                                {{ errors[0] }}
                                              </div>
                                              </b-form-group>
                                              </ValidationProvider>
                                              </b-col>
                                              <b-col xl="6" lg="6" sm="12">
                                              <ValidationProvider name="Legal Guardian (En)" vid="legal_guardian" rules="required">
                                              <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="legal_guardian"
                                              slot-scope="{ valid, errors }"
                                              >
                                             <template v-slot:label>
                                                {{$t('child_admission_management.legal_guardian_en')}}
                                             </template>
                                             <b-form-input
                                              id="legal_guardian"
                                              v-model="assign.legal_guardian"
                                             :state="errors[0] ? false : (valid ? true : null)"
                                                 disabled
                                             ></b-form-input>
                                             <div class="invalid-feedback">
                                               {{ errors[0] }}
                                             </div>
                                             </b-form-group>
                                             </ValidationProvider>
                                             </b-col>
                                             <b-col lg="6" sm="12">
                                             <ValidationProvider name="Legal Guardian (Bn)" vid="legal_guardian_bn" rules="required">
                                             <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="legal_guardian_bn"
                                                slot-scope="{ valid, errors }"
                                             >
                                             <template v-slot:label>
                                               {{$t('child_admission_management.legal_guardian_bn')}}
                                             </template>
                                             <b-form-input
                                             id="legal_guardian_bn"
                                             v-model="assign.legal_guardian_bn"
                                             :state="errors[0] ? false : (valid ? true : null)"
                                              disabled
                                             ></b-form-input>
                                             <div class="invalid-feedback">
                                             {{ errors[0] }}
                                             </div>
                                             </b-form-group>
                                             </ValidationProvider>
                                             </b-col>
                                             <b-col xl="6" lg="6" sm="12">
                                             <ValidationProvider name="Date" vid="date" rules="required">
                                             <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="date"
                                              slot-scope="{ valid, errors }"
                                              >
                                              <template v-slot:label>
                                              {{$t('child_admission_management.dismissed_date')}} <span class="text-danger">*</span>
                                              </template>
                                              <b-form-input
                                              class="date-picker"
                                              v-model="assign.date"
                                              placeholder="Select Date"
                                              id="date"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              ></b-form-input>
                                              <div class="invalid-feedback">
                                              {{ errors[0] }}
                                              </div>
                                              </b-form-group>
                                              </ValidationProvider>
                                              </b-col>
                                              </b-row>
                                              <!-- Reason (EN) -->
                                              <b-row>
                                              <b-col xl="12" lg="12" sm="12">
                                              <ValidationProvider name="Reason (EN)" vid="reason" rules="required">
                                              <b-form-group
                                               class="row"
                                               label-cols-sm="2"
                                               label-for="reason"
                                               slot-scope="{ valid, errors }"
                                              >
                                               <template v-slot:label>
                                               {{$t('child_admission_management.dismissed_reason_en')}} <span class="text-danger">*</span>
                                               </template>
                                               <b-form-textarea
                                               id="reason"
                                               v-model="assign.reason"
                                               :state="errors[0] ? false : (valid ? true : null)"
                                               rows="2"
                                               max-rows="6"
                                               ></b-form-textarea>
                                               <div class="invalid-feedback">
                                                {{ errors[0] }}
                                              </div>
                                              </b-form-group>
                                              </ValidationProvider>
                                              </b-col>
                                              </b-row>
                                              <b-row>
                                              <b-col xl="12" lg="12" sm="12">
                                              <ValidationProvider name="Reason (BN)" vid="reason_bn" rules="required">
                                              <b-form-group
                                              class="row"
                                              label-cols-sm="2"
                                              label-for="reason_bn"
                                              slot-scope="{ valid, errors }"
                                              >
                                              <template v-slot:label>
                                                 {{$t('child_admission_management.dismissed_reason_bn')}} <span class="text-danger">*</span>
                                              </template>
                                              <b-form-textarea
                                              id="reason_bn"
                                              v-model="assign.reason_bn"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              rows="2"
                                              max-rows="6"
                                              ></b-form-textarea>
                                              <div class="invalid-feedback">
                                               {{ errors[0] }}
                                              </div>
                                              </b-form-group>
                                              </ValidationProvider>
                                              </b-col>
                                              </b-row>
                                             <!-- Save/Cancel -->
                                              <div class="row">
                                              <div class="col-sm-3"></div>
                                              <div class="col text-right">
                                              <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                                &nbsp;
                                              <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                              </div>
                                             </div>
                               </b-overlay>
                             </b-form>
                          </ValidationObserver>
                        </b-col>
                      </b-row>
                </template>
              </iq-card>
            </b-col>
        </b-row>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { dismissedChildrenStoreApi, getDismissedChildren, dismissedChildrenUpdateApi } from '../../api/routes'
import flatpickr from 'flatpickr'
import { isNotEmpty } from '@amcharts/amcharts4/.internal/core/utils/Utils'

export default {
  props: ['id', 'item'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      assign: {
        online_admission_id: 0,
        student_type: '',
        class_id: 0,
        office_id: 0,
        office_type_id: 0,
        registration_id: '',
        applicants_name: '',
        date: '',
        address: '',
        address_bn: '',
        contact_no: '',
        institute_type: '',
        org_name: '',
        org_id: '',
        institute_name: '',
        resident_name_bn: '',
        legal_guardian: '',
        legal_guardian_bn: '',
        class: 0,
        school_name: 0,
        school_id: 0,
        reason: '',
        reason_bn: ''
      },
      external: true,
      notFound: false,
      unitLoad: false,
      schoolList: []
    }
  },
  computed: {
    classList: function () {
     return this.$store.state.ChildService.commonObj.classList.filter(item => item.status === 1)
    },
    // schoolList: function () {
    //  return this.$store.state.ChildService.commonObj.schoolList.filter(item => item.status === 1)
    // },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  created () {
    if (this.id) {
      const tmp = this.getAssignData()
      // Object.freeze(tmp)
      this.assign = tmp
      this.nodata = false
    }
  },
  mounted () {
        flatpickr('.date-picker', {})
  },
  watch: {
      'assign.registration_id': function (newVal, oldVal) {
          this.notFound = false
            this.assign.name = ''
            this.assign.name_bn = ''
            this.assign.address = ''
            this.assign.address_bn = ''
            this.assign.org_name = ''
            this.assign.contact_no = ''
            this.assign.legal_guardian = ''
            this.assign.legal_guardian_bn = ''
            this.assign.student_type = ''
            this.assign.institute_type = ''
            this.assign.institute_name = ''
            if (oldVal !== newVal) {
                if (newVal.length === 11) {
                    this.getResident(newVal)
                }
            }
        },
         'assign.school_id': function (newVal) {
           if (newVal === 0) {
             this.external = true
           } else {
             this.external = false
           }
        }
  },
  methods: {
        getClassName (id) {
            const className = this.$store.state.ChildService.commonObj.classList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return className.text_bn
            } else {
                return className.text_en
            }
        },
      getResident ($regId) {
          this.unitLoad = true
          RestApi.getData(childServiceBaseUrl, getDismissedChildren + '/' + $regId).then(response => {
              if (isNotEmpty(response.data)) {
                this.assign.name = response.data.name
                this.assign.online_admission_id = response.data.id
                this.assign.name_bn = response.data.name_bn
                this.assign.address = response.data.address
                this.assign.contact_no = response.data.contact_no
                this.assign.address_bn = response.data.address_bn
                this.assign.legal_guardian = response.data.legal_guardian
                this.assign.legal_guardian_bn = response.data.legal_guardian_bn
                this.assign.org_name = this.getOrgName(response.data.org_id)
                this.assign.student_type = this.getStudentType(response.data.student_type)
                this.assign.institute_type = this.getInstituteType(response.data.office_type_id)
                this.assign.institute_name = this.getInstituteName(response.data.office_id)
                this.schoolList = this.getSchoolList(response.data.office_id)
                this.notFound = false
              } else {
                this.notFound = true
              }
              this.unitLoad = false
          })
        },
        getSchoolList (officeId) {
          return this.$store.state.ChildService.commonObj.schoolList.filter(item => item.status === 1 && item.office_id === officeId)
        },
        getAssignData () {
          const tmpData = this.$store.state.list.find(item => item.id === this.id)
          return JSON.parse(JSON.stringify(tmpData))
        },
        getOrgName (orgId) {
                const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
                if (this.$i18n.locale === 'bn') {
                    return tmpData.text_bn
                } else {
                    return tmpData.text_en
                }
        },
        getStudentType (typeId) {
        const Type = this.$store.state.ChildService.commonObj.studentTypeList.find(type => type.value === typeId)
        if (this.$i18n.locale === 'bn') {
            return Type.text_bn
        } else {
            return Type.text_en
        }
        },
        getInstituteType (Id) {
            const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getInstituteName (Id) {
            const tmpData = this.$store.state.commonObj.officeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        async saveData () {
          this.unitLoad = true
          this.$store.dispatch('mutateCommonProperties', { loading: true })
          let result = null
          const loadinState = { loading: false, listReload: true }
          if (this.id) {
              result = await RestApi.putData(childServiceBaseUrl, `${dismissedChildrenUpdateApi}/${this.id}`, this.assign)
          } else {
              result = await RestApi.postData(childServiceBaseUrl, dismissedChildrenStoreApi, this.assign)
          }
          this.$store.dispatch('mutateCommonProperties', loadinState)
          if (result.success) {
              this.unitLoad = false
              this.$toast.success({
                  title: 'Success',
                  message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                  color: '#D6E09B'
              })
              this.$bvModal.hide('modal-4')
          } else {
              this.unitLoad = false
              this.$toast.error({
                  title: this.$t('globalTrans.error'),
                  message: result.message,
                  color: '#D6E09B'
              })
              this.$refs.form.setErrors(result.errors)
          }
      }
    }
}

</script>
